<template>
  <div
    :style="{
      width: '100%',
      height: '100%',
      borderRadius,
      backgroundColor,
      borderStyle,
      borderWidth,
      paddingTop,
      borderColor
    }">
  </div>
</template>

<script>
import paperElementMixin from '@/mixins/paperElementMixin'

export default {
  mixins: [paperElementMixin],
  props: {
    borderRadius: {
      type: String,
      default: undefined
    },
    borderStyle: {
      type: String,
      default: undefined
    },
    borderWidth: {
      type: [Number, String],
      default: undefined
    },
    borderColor: {
      type: String,
      default: undefined
    },
    backgroundColor: {
      type: String,
      default: undefined
    },
    paddingTop: {
      type: String,
      default: '0'
    }
  }
}
</script>
<style scoped>
</style>
